import { Box, Chip, Divider, Paper, Stack, Typography } from "@mui/material";
import { AccountCourseAttendanceDto } from "../../../api/psc";

export default function AttendanceHistoryListItem(props: {
    item: AccountCourseAttendanceDto;
}) {
    return (
        <Paper sx={{ p: 2 }}>
            <Stack spacing={1.5}>
                <Typography color="primary">
                    {props.item.course.title}
                </Typography>

                <Typography color="text.secondary">
                    {props.item.course.description}
                </Typography>

                <Typography color="secondary">
                    {props.item.course.humanReadableDate}
                </Typography>

                {props.item.employees.length > 0 && (
                    <>
                        <Divider />

                        <Stack spacing={1.5} divider={<Divider />}>
                            {props.item.employees.map((e) => {
                                const attendanceTitle = e.isAttended
                                    ? "حضور"
                                    : "عدم حضور";
                                const attendanceColor = e.isAttended
                                    ? "primary"
                                    : "error";

                                return (
                                    <Stack
                                        key={e.employee.id}
                                        direction="row"
                                        spacing={1}
                                        alignItems="center"
                                    >
                                        <Typography color="primary">
                                            {e.employee.displayName}
                                        </Typography>

                                        <Box flexGrow={1} />

                                        <Chip
                                            size="small"
                                            label={attendanceTitle}
                                            color={attendanceColor}
                                        />
                                    </Stack>
                                );
                            })}
                        </Stack>
                    </>
                )}
            </Stack>
        </Paper>
    );
}
